export default __webpack_public_path__ + "google-drive.5238fefd.png";